import styled, { css, StyledComponent } from 'styled-components';

export const AttributeSelectWrapper: StyledComponent<
  'div',
  any,
  { suffixIconWidth?: number | undefined },
  never
> = styled.div<{
  suffixIconWidth?: number;
}>`
  .emp-ant-select-single.emp-ant-select-show-arrow .emp-ant-select-selection-item {
    ${({ suffixIconWidth = 100 }) => {
      return css`
        padding-inline-end: ${suffixIconWidth}px;
      `;
    }}
  }
`;

export const NamedSelectWithExtrasWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 535px;

  &:hover > div {
    color: #0046ff;
  }
`;

export const StyledSelectOption = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const TypeSelectWrapper = styled.div`
  .emp-ant-select-selection-item {
    padding-inline-end: 20px !important;
  }
`;

export const TypeValue = styled.div`
  height: 32px;
  padding: 4px 11px;
  border: 1px solid rgb(217, 217, 217);
  background-color: rgb(255, 255, 255);
  line-height: 22px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
`;
